module.exports = __webpack_public_path__ + "img/logo1.beb9cfaa.png";